






















import { Component, Prop } from 'vue-property-decorator';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import ProductSubType from '@/models/Products/ProductSubType';

@Component({ name: 'DepositCardSettingsEdit', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    @Prop({ required: true })
    isCreate: boolean

    @Prop({ required: false })
    productSubType: ProductSubType

    get productVM() {
        if (this.isCreate) {
            if (this.productSubType === ProductSubType.DepositCurrentAccount) {
                ProductWizardModule.createProductViewModel.depositCardSettingsAvailable = true;
            }
            return ProductWizardModule.createProductViewModel;
        }
        return ProductDetailsModule.productVM;
    }

}
